import { Typography } from '@mui/material';

type CommonTitleProps = {
    title: string;
}

export function CommonTitle({ title }: Readonly<CommonTitleProps>) {
    return (
        <Typography
            variant="h6"
            component="span"
            sx={{ fontWeight: 'bold' }}
        >
            {title}
        </Typography>
    );
}
